import { PollState } from '../services/DataService';

export enum PollEventTypeCode {
    Lecture = 0,
    RoundTable = 1,
    Conference = 2,
    BayerConference = 3,
    ForeignCongress = 4,
}

export enum PollType {
    Fast = 0,
    Complex = 1,
}

export default interface IPoll {
    Id?: string;
    Title?: string;
    Description?: string;
    Slug?: string;
    SlugDeck?: string;
    State?: PollState;
    SingleResponse?: boolean;
    OpensAt?: string;
    ClosesAt?: string;
    AuthorId?: string;
    AuthorName?: string;
    EditorId?: string;
    Created: Date;
    Updated?: string;
    BrandingBackgroundType?: number;
    BrandingBackgroundColor?: string | null;
    BrandingBackgroundGradient?: string | null;
    BrandingLogoUrl?: string | null;
    BrandingLogoPositionCode?: number | null;
    BrandingLogoSize?: number | null;
    QrcodeVisible?: boolean;
    QrcodePositionCode?: number;
    QrcodeForeground?: string | null;
    QrcodeBackground?: string | null;
    StatusChangedAt?: string | null;
    StatusChangedBy?: string | null;
    StatusPrevious?: number | null;
    CompletedDisplayResults?: boolean;
    CompletedMessage?: string | null;
    ResponseCount?: number;
    Number?: number;
    Quick?: boolean;
    Type?: PollType;
    GeoRegionId?: string | null;
    GeoTerritoryId?: string | null;
    EventTypeCode?: PollEventTypeCode;
}
